const posts_management_zh = {
  edit_posts_info:'编辑职位信息',
  empty_posts_name:'请输入职位名称',
  empty_posts_code:'请输入职位编码'
}

export default posts_management_zh



// WEBPACK FOOTER //
// ./src/common/lang/posts_management/posts_management_zh.js